import { Block } from '@shared/models';

export const listingPoigneesMock: Block<null> = {
  type: 'listing-poignees',
  data: null,
};
